export const slides = [
  {
    url: "https://images.unsplash.com/photo-1578916171728-46686eac8d58?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1600&q=80",
  },
  {
    url: "https://images.unsplash.com/photo-1620646146961-fb8c077b6b61?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1600&q=80",
  },
  {
    url: "https://images.unsplash.com/photo-1491553895911-0055eca6402d?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1600&q=80",
  },

  {
    url: "https://images.unsplash.com/photo-1491933382434-500287f9b54b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1600&q=80",
  },
];

// export const data = [
//   {
//     id: 1,
//     name: "Purefoods",
//     category: "Corned Beef",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/04808887010077/a039215c67438fb5669e06b7ad6c6321_large.png&width=256&type=webp&quality=80",
//     price: "150",
//   },
//   {
//     id: 2,
//     name: "Argentina",
//     category: "Corned Beef",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684702504559/89d4a739dec9a4eb7c4f06d5d8c17887_large.png&width=256&type=webp&quality=80",
//     price: "145",
//   },
//   {
//     id: 3,
//     name: "CDO",
//     category: "Corned Beef",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684702539926/6104e49b211569587b50b3bd5f32d422_large.png&width=256&type=webp&quality=80",
//     price: "150",
//   },
//   {
//     id: 4,
//     name: "Lucky 7",
//     category: "Corned Beef",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684702504587/600209e26f5f56a20be717dc44fb0a15_large.png&width=256&type=webp&quality=80",
//     price: "150",
//   },
//   {
//     id: 5,
//     name: "Mega",
//     category: "Sardines",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684702546685/6ee53065d98ef22b8abf3d0194e33e85_large.png&width=256&type=webp&quality=80",
//     price: "80",
//   },
//   {
//     id: 6,
//     name: "555",
//     category: "Sardines",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/00748485200019/109d77d4d781d59b3ebfe8d7abeeb8b5_large.png&width=256&type=webp&quality=80",
//     price: "80",
//   },
//   {
//     id: 7,
//     name: "Master",
//     category: "Sardines",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/8195350/5ee1caa108f849e630fcf102bfdb9079_large.png&width=256&type=webp&quality=80",
//     price: "80",
//   },
//   {
//     id: 8,
//     name: "Saba",
//     category: "Sardines",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/8178230/127c50bc4801cb38e94bfd7a45d48135_large.png&width=256&type=webp&quality=80",
//     price: "80",
//   },
//   {
//     id: 9,
//     name: "Ho-Mi",
//     category: "Noodles",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684702545391/f1608a988281f55f31035584642879ca_large.png&width=256&type=webp&quality=80",
//     price: "20",
//   },
//   {
//     id: 10,
//     name: "Payless",
//     category: "Noodles",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/5527000/70ef10e00691b97d4e64aa96662a17fa_large.png&width=256&type=webp&quality=80",
//     price: "20",
//   },
//   {
//     id: 11,
//     name: "Nissin",
//     category: "Noodles",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684702535832/f6054aefe042d3481996fce684698a79_large.png&width=256&type=webp&quality=80",
//     price: "20",
//   },
//   {
//     id: 12,
//     name: "Jin Ramen",
//     category: "Noodles",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684702557027/3801f6305a10e4b1d92ebcc416767a60_large.png&width=256&type=webp&quality=80",
//     price: "20",
//   },
//   {
//     id: 13,
//     name: "Oishi",
//     category: "Chips",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684704927203/eb7433d9bdacc6ccc95a1048d139c5c5_large.png&width=256&type=webp&quality=80",
//     price: "10",
//   },
//   {
//     id: 14,
//     name: "Cheez It",
//     category: "Chips",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/8195426/fcb5a23e17829628ecc2353c9d2f593e_large.png&width=256&type=webp&quality=80",
//     price: "20",
//   },
//   {
//     id: 15,
//     name: "Piattos",
//     category: "Chips",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684713442678/04e67509d466b697df2aa574e23fbd79_large.png&width=256&type=webp&quality=80",
//     price: "20",
//   },
//   {
//     id: 16,
//     name: "Roller Coaster",
//     category: "Chips",
//     image:
//       "https://ipcdn.freshop.com/resize?url=https://images.freshop.com/1564405684702504136/2f152315a29e46120f1d92518f39725f_large.png&width=256&type=webp&quality=80",
//     price: "20",
//   },
// ];
